import moment from "moment";

const generateDates =  (fromDate, toDate, dateFormat = "YYYY-MM-DD") => {
  let dates = [];
  if (fromDate && toDate) {
    let startDate = moment(fromDate);
    const endDate = moment(toDate);
    dates.push(startDate.format(dateFormat))
    while (!moment(startDate).isSame(endDate)) {
      startDate = startDate.add(1, "day");
      dates.push(startDate.format(dateFormat));
    }
  }
  return dates;
};

 const generateDateRange = (start, end) => {
  const dates = [];
  let current = moment(end);
  const startDate = moment(start);
  while (current.isSameOrAfter(startDate, "day")) {
    dates.push(current.clone());
    current.subtract(1, "day");
  }
  return dates;
};

export { generateDates, generateDateRange };